import { Component } from "react"
import { PropTypes } from "prop-types"
import { Paper, Button } from "@mui/material"
import classNames from "classnames"
import { Search } from "@mui/icons-material"
import Factor from "./factor"
import Autocomplete from "components/material/autocomplete"
import "./style.scss"
import { EXPOSURE_CONSTRAINT_WEIGHTINGS } from "helpers/contentSetConstants"

class Factors extends Component {
  static propTypes = {
    factorsSearchResults: PropTypes.array,
    factorsSearchValue: PropTypes.string,
    factorsSearch: PropTypes.func.isRequired,
    applyConstraints: PropTypes.func.isRequired,
    setFactors: PropTypes.func.isRequired,
    resetFactorSearch: PropTypes.func.isRequired,
    removeActivatedFactor: PropTypes.func.isRequired,
    removeCurrentFactor: PropTypes.func.isRequired,
    toggleFactorsSearch: PropTypes.func.isRequired,
    factors: PropTypes.array,
    applyExposureButtonEnabled: PropTypes.bool.isRequired,
    factorsSearchVisible: PropTypes.bool.isRequired,
    factorsErrors: PropTypes.bool.isRequired,
    reversedActions: PropTypes.bool,
  }

  onApply = () => {
    const { applyConstraints, factors } = this.props
    const constraint = factors.map(({ id, contentSetId, min, max, isCurrency }) => ({
      id,
      contentSetId,
      min,
      max,
      exposureWeighting: isCurrency ? EXPOSURE_CONSTRAINT_WEIGHTINGS.CURRENCY : EXPOSURE_CONSTRAINT_WEIGHTINGS.PERCENT,
    }))

    applyConstraints("exposure", constraint)
  }

  addFactor = (factor) => {
    const { setFactors, resetFactorSearch } = this.props
    setFactors(factor.id, factor.contentSetId)
    resetFactorSearch()
  }

  removeFactor = (factor) => {
    const { removeActivatedFactor, removeCurrentFactor } = this.props

    if (Number.isFinite(factor.originalMin) || Number.isFinite(factor.originalMax)) {
      removeCurrentFactor(factor.id, factor.contentSetId)
    }

    removeActivatedFactor(factor.id, factor.contentSetId)
  }

  updateFactor = (factorId, contentSetId, min, max, exposureWeighting) => {
    const { setFactors, resetFactorSearch } = this.props
    setFactors(factorId, contentSetId, min, max, exposureWeighting)
    resetFactorSearch()
  }

  render() {
    const {
      factorsSearchResults,
      factorsSearchValue,
      factorsSearch,
      factors,
      applyExposureButtonEnabled,
      factorsSearchVisible,
      toggleFactorsSearch,
      factorsErrors,
      reversedActions,
    } = this.props

    return <div className="factors-settings">
      <div className="factors-wrapper">
        <div className="factors-header">
          <div className="number-of-factors-wrapper">
            <div className="number-of-factors">{factors.length}/4 Factors</div>
          </div>
          <div className="minimum">Minimum</div>
          <div className="maximum">Maximum</div>
          <div className="z-score">Current Exposure</div>
        </div>
        <div className="factor-wrapper">
          {factors.map(factor =>
            <Factor
              key={factor.id}
              factor={factor}
              removeFactor={this.removeFactor}
              updateFactor={this.updateFactor}
            />,
          )}
          {factorsSearchVisible
            && <Paper square>
              <div className="factor-autocomplete-wrapper">
                <Search className="search-icon" />
                <div className="autocomplete-wrapper">
                  <Autocomplete
                    autoFocus
                    label="Search Factors"
                    disabled={factors.length === 4}
                    searchResults={factorsSearchResults}
                    value={factorsSearchValue}
                    selectItem={this.addFactor}
                    search={factorsSearch}
                  />
                </div>
              </div>
            </Paper>}
        </div>
        {!factorsSearchVisible && factors.length < 4
          && <Button
            className="search-factors-button"
            variant="outlined"
            size="large"
            color="primary"
            onClick={toggleFactorsSearch}
          >
            Add factor
          </Button>}
      </div>
      <div className={classNames("buttons-bar", { reversed: reversedActions })}>
        <Button
          variant="contained"
          color="primary"
          onClick={this.onApply}
          disabled={!applyExposureButtonEnabled || factorsErrors}
        >
          Apply
        </Button>
      </div>
    </div>
  }
}

export default Factors
